// src/authProvider.js
export const authProvider = {
  login: ({ username, password }) => {
    // Basic token = base64("user:pass")
    const token = btoa(`${username}:${password}`);
    localStorage.setItem("basicAuth", token);
    return Promise.resolve();
  },

  logout: () => {
    localStorage.removeItem("basicAuth");
    return Promise.resolve();
  },

  checkAuth: () => {
    return localStorage.getItem("basicAuth")
      ? Promise.resolve()
      : Promise.reject();
  },

  checkError: (error) => {
    // React-Admin chiama questa se riceve errori dal dataProvider
    const status = error?.status || error?.response?.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem("basicAuth");
      return Promise.reject();
    }
    return Promise.resolve();
  },

  getPermissions: () => Promise.resolve(),
};
